import { useContext, useState } from 'react';
import * as R from 'ramda';

import TeamContext, {
  baseUserGroup,
} from '@atom/components/teamPortal/TeamContext';
import CreateEditUserGroupModal from '@atom/components/teamPortal/teamControls/CreateEditUserGroupModal';
import DeleteUserGroupModal from '@atom/components/teamPortal/teamControls/DeleteUserGroupModal';
import TeamCreateControls from '@atom/components/teamPortal/teamControls/TeamCreateControls';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { DeleteIcon, EditIcon, SettingsIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './userGroupsTable.module.css';

const UserGroupControls = () => {
  const [, { Link }] = useNavigation();
  const { activeGroup } = useContext(TeamContext);

  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);

  const isRoot = activeGroup?.id === baseUserGroup.id;
  const isLeaf = R.isEmpty(activeGroup?.userGroups);

  return (
    <>
      <div className={classes.groupControlsContainer}>
        {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
          <TeamCreateControls userGroup={activeGroup} />
        )}
        {!isRoot && hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
          <IconButton onClick={() => setEditOpen(true)}>
            <Icon color={colors.neutral.gray} icon={EditIcon} />
          </IconButton>
        )}
        {!isRoot && (
          <Link to={`/team/group/${activeGroup?.id}`}>
            <IconButton>
              <Icon color={colors.neutral.gray} icon={SettingsIcon} />
            </IconButton>
          </Link>
        )}
        {isLeaf && !isRoot && hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
          <IconButton onClick={() => setDeleteOpen(true)}>
            <Icon color={colors.neutral.gray} icon={DeleteIcon} />
          </IconButton>
        )}
      </div>
      <CreateEditUserGroupModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        groupId={activeGroup?.id}
        groupColorId={activeGroup?.colorId}
        groupName={activeGroup?.name}
        isEdit
      />
      <DeleteUserGroupModal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        userGroup={activeGroup}
      />
    </>
  );
};

export default UserGroupControls;
